function downloadCSV(v, asName) {
  // 'v' is a 2D array
  const a = document.createElement('a');
  a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(v.map(x => x.map(y => _.isNil(y) ? '' : ((typeof y == 'string') && /^\s|\s$|,|"|\n/.test(y)) ? ('"' + y.replace(/"/g, '""') + '"') : y).join(',')).join('\n'));
  a.download = asName;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export default downloadCSV;
